import { useCallback, useState } from 'react';

/**
 * Trạng thái "chọn nhiều nhóm" ở sảnh — dùng CHUNG cho cả hai dải nhóm (đang
 * chạy + của tôi), nên sống ở `LobbyPage` chứ không trong từng section.
 */
export interface GroupSelection {
  /** Đang ở chế độ chọn (hiện ô tick trên thẻ). */
  selecting: boolean;
  selected: ReadonlySet<string>;
  /** Bật/tắt chế độ chọn — tắt thì xoá luôn lựa chọn. */
  toggleSelecting: () => void;
  toggle: (groupId: string) => void;
  /** Đặt lựa chọn thành đúng danh sách này (dùng cho "chọn tất cả"). */
  replace: (groupIds: string[]) => void;
  clear: () => void;
}

export function useGroupSelection(): GroupSelection {
  const [selecting, setSelecting] = useState(false);
  const [selected, setSelected] = useState<Set<string>>(() => new Set());

  const toggleSelecting = useCallback(() => {
    setSelecting((on) => !on);
    setSelected(new Set()); // vào hay ra chế độ chọn đều bắt đầu từ trạng thái sạch
  }, []);

  const toggle = useCallback((groupId: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(groupId)) next.delete(groupId);
      else next.add(groupId);
      return next;
    });
  }, []);

  const replace = useCallback((groupIds: string[]) => {
    setSelected(new Set(groupIds));
  }, []);

  const clear = useCallback(() => {
    setSelected(new Set());
  }, []);

  return { selecting, selected, toggleSelecting, toggle, replace, clear };
}
